var _style, _path, _path2, _defs, _path3, _g, _g2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewLogoWithPaddings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 288 288",
    style: {
      enableBackground: "new 0 0 288 288"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#163F70;}\n\t.st1{fill:#ADCCEB;}\n\t.st2{clip-path:url(#SVGID_00000146469620127403030000000017702321421889079219_);}\n\t.st3{fill:#E1ECF8;}\n\t.st4{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.4211;stroke-miterlimit:10;}\n\t.st5{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.4842;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M260.4,107.6c-9.5-30.9-30.4-56.3-59-71.4c-28.5-15.2-61.3-18.3-92.2-8.8c-30.9,9.5-56.3,30.4-71.4,59 c-15.2,28.5-18.3,61.3-8.8,92.2c15.9,52,64,85.6,115.8,85.6c11.7,0,23.6-1.7,35.4-5.3C243.9,239.2,279.9,171.4,260.4,107.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M145.5,48.1c-52.5,0-95.1,42.7-95.1,95.1c0,52.5,42.7,95.1,95.1,95.1c52.5,0,95.1-42.7,95.1-95.1 C240.6,90.8,198,48.1,145.5,48.1z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M240.7,143.2c0,52.6-42.6,95.2-95.2,95.2c-52.6,0-95.2-42.6-95.2-95.2C50.4,90.6,93,48,145.6,48 C198.1,48,240.7,90.6,240.7,143.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000000934318049529001150000004824871826436240806_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000000934318049529001150000004824871826436240806_)"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M139.4,202.4c-13.1-15.3-35.6-35.7-62.1-35.7v23.2c23.6,0,47.5,29.7,54.8,41.1l11.8,18.6l8.7-20.2 C153,228,208.4,100.4,279,56.9l-12.2-19.7C206,74.7,157.9,164.1,139.4,202.4z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "77.3,168 82.2,168 82.2,153.6 93,153.6 93,149.3 82.2,149.3 82.2,140.7 96.8,140.7 96.8,136.3  77.3,136.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M102.7,147.4v-2.6h-4.5V168h4.5v-12.7c1.4-4.5,3.3-6.3,6.4-6.4l0.7,0v-4.5H109 C106,144.4,104.1,145.5,102.7,147.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.8,
    y: 135.9,
    className: "st0",
    width: 4.5,
    height: 5.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.8,
    y: 144.7,
    className: "st0",
    width: 4.5,
    height: 23.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M138.4,161c-1.2,2.1-3.1,3.3-5.4,3.3c-3,0-5.4-2.8-5.6-6.6h14.1V155c0-6.7-3.4-10.6-9-10.6 c-5.8,0-9.6,4.7-9.6,12.1c0,8.9,5.5,12.1,10.2,12.1c5.2,0,7.5-2.8,9-5.4l0.4-0.7l-3.7-1.9L138.4,161z M127.5,153.6 c0.3-2.2,1.4-5.2,5-5.2c2.5,0,4.2,2,4.4,5.2H127.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M155.7,144.3c-2,0-4,0.8-5.8,2.4v-2h-4.5V168h4.5v-16.7c1.4-1.4,3.6-2.8,5.5-2.8c1.7,0,2.8,0.5,2.8,3.1V168 h4.5v-16.6C162.7,147,160.1,144.3,155.7,144.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M185.2,163.4l0-27.1h-4.5v9.8c-1.4-0.9-3.2-1.8-5.1-1.8c-4.6,0-9.5,3.8-9.5,12.1c0,8.9,5.2,12.1,9.7,12.1 c2,0,3.9-0.7,5.3-1.7l0.3,1.3h4.3l-0.1-0.9C185.2,165.9,185.2,164.7,185.2,163.4z M180.7,151v10.8c-1.9,1.9-3.1,2.5-4.7,2.5 c-3.4,0-5.4-2.8-5.4-7.8c0-5.4,1.8-8.1,5.4-8.1C177.4,148.4,179.2,149.4,180.7,151z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.5,
    y: 136.3,
    className: "st0",
    width: 4.5,
    height: 31.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M213.5,144.7l-4.6,15.1l-5.3-15.1h-4.8l7.8,22.8c-0.9,3.9-3,4.4-4.9,4.4c-0.5,0-0.9,0-1.3-0.1l-1.1-0.1v4 l0.7,0.1c0.1,0,0.3,0,0.4,0.1c0.5,0.1,1,0.2,1.8,0.2c3.9,0,6.6-2.2,8-6.6l8-24.7H213.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115.8,99.3l-9.8,31.7h5.1l2.8-9.5h9.7l2.8,9.5h5.1l-9.8-31.7H115.8z M122.4,117.2h-7.1l3.6-12.8L122.4,117.2 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M171.5,124c-1.2,2.1-3.1,3.3-5.4,3.3c-3,0-5.4-2.8-5.6-6.6h14.1V118c0-6.7-3.4-10.6-9-10.6 c-5.8,0-9.6,4.7-9.6,12.1c0,8.9,5.5,12.1,10.2,12.1c5.2,0,7.5-2.8,9-5.4l0.4-0.7l-3.7-1.9L171.5,124z M160.6,116.6 c0.3-2.2,1.4-5.2,5-5.2c2.5,0,4.2,2,4.4,5.2H160.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M148.2,109.3c-1.4-1.3-3.2-1.9-5.4-1.9c-4.5,0-9.7,3.2-9.7,12.1c0,8.3,4.9,12.1,9.5,12.1 c1.9,0,3.7-0.8,5.1-1.7c-0.4,2.2-1.5,5.3-4.9,5.3c-2.5,0-3.7-0.8-5.2-3.4l-0.4-0.7l-3.6,2.2l0.4,0.7c2.1,3.4,4.2,5.4,8.7,5.4 c2.5,0,4.7-0.8,6.3-2.5c1.8-1.7,2.9-4.3,3.2-7.4l0-21.5h-3.8L148.2,109.3z M143.1,111.5c1.6,0,2.8,0.6,4.7,2.5v10.8 c-1.5,1.6-3.3,2.5-4.7,2.5c-3.6,0-5.4-2.7-5.4-8.1C137.7,114.3,139.6,111.5,143.1,111.5z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M55.8,86.3c1.2,0.9,3.8,3.6,0.9,8.9c-2,3.7-5.7,5.5-9.9,3.2c-3.4-1.9-4.8-5.4-2.2-10c2.8-5.2,6.7-4.1,7.4-4 l-1.2,2.3c-0.5-0.1-2.6-0.1-4.1,2.6c-1.8,3.2-0.7,5.6,1.7,6.9c2.7,1.5,5.2,0.3,6.5-2.2c1.5-2.7,0.5-4.7-0.3-5.4L55.8,86.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M52.8,75.7l7.5-9.3l1.7,1.4l-5.9,7.3l2.4,1.9l5.1-6.3l1.7,1.4l-5.1,6.2l2.7,2.2l6-7.4l1.7,1.4l-7.6,9.4 L52.8,75.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M65.8,60.8l6.1-5.2c2.4-2,4.6-3,6.7-0.5c1.6,1.9,1.1,4-0.3,5.4l6.6,1.5L82.5,64l-6.3-1.5L73,65.3l3.4,4l-2,1.7 L65.8,60.8z M75.4,60.4c1.6-1.4,2.2-2.3,1.2-3.5c-1-1.2-2-0.7-3.6,0.7l-3.8,3.3l2.4,2.9L75.4,60.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M88.2,46.9l-5.2,3l-1.1-1.9l12.6-7.2l1.1,1.9l-5.2,3l5.5,9.6l-2.3,1.3L88.2,46.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M101.1,37.9l2.4-1l5,12.3l-2.4,1L101.1,37.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M111.4,34l11.9-3.1l0.6,2.2l-9.3,2.4l0.8,3l8-2.1l0.6,2.2l-8,2.1l1.4,5.6l-2.5,0.7L111.4,34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M130.3,30l2.6-0.3l1.6,13.2l-2.6,0.3L130.3,30z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M141.3,29l11.9,0.2l0,2.2l-9.3-0.2l-0.1,3.1l8,0.1l0,2.2l-8-0.1l-0.1,3.5l9.5,0.2l0,2.2l-12.1-0.2L141.3,29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M161,30l6.3,1.3c4.1,0.8,7.1,3.2,6.1,7.9c-0.9,4.5-4.3,6-8.7,5.1l-6.4-1.3L161,30z M164,41.9 c4.3,0.9,6.3-0.1,6.9-3.2c0.6-3.2-0.9-4.6-5.2-5.5l-2.6-0.5l-1.7,8.7L164,41.9z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M120.8,241.1l11.7,2.2l-0.4,2.2l-9.2-1.8l-0.6,3l7.9,1.5l-0.4,2.2L122,249l-0.7,3.4l9.4,1.8l-0.4,2.2 l-11.9-2.3L120.8,241.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M139.7,247.1L139.7,247.1l-0.1,10.1l-2.3,0l0-13.3l3.5,0l4.1,9.9l4.3-9.9l3.4,0l0,13.3l-2.3,0l0-10.1h0 l-4.3,10.1l-2.1,0L139.7,247.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M158.3,243.2l7.3-1.4c2.2-0.4,5.8-1.1,6.6,2.9c0.8,4-2.9,4.7-5.1,5.1l-4.7,0.9l1,5.1l-2.6,0.5L158.3,243.2z  M167.3,247.5c1.5-0.3,2.7-0.7,2.4-2.4c-0.3-1.7-1.6-1.5-3.1-1.3l-5.3,1l0.7,3.6L167.3,247.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M175.7,239.3l2.4-0.9l3.9,10.3l9-3.4l0.8,2.2l-11.4,4.4L175.7,239.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M197.2,229c5-3,8.6-1.2,10.4,1.9c1.4,2.4,2.2,6.7-3.2,10c-5.4,3.3-8.9,0.6-10.3-1.8 C192.2,236,192.2,232,197.2,229z M205.3,232.1c-1.7-2.7-4.4-2.8-7-1.3c-2.6,1.6-3.8,4-2.1,6.8c2,3.2,4.9,2.6,7,1.3 C205.4,237.7,207.3,235.3,205.3,232.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M216.5,225.1l-10.2-1.6l2.4-2.1l7.2,1.1l-0.3-7.3l2.4-2.1l0.5,10.3l3.5,4l-1.9,1.7L216.5,225.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M220.9,209.7l7.3-9.4l1.8,1.4l-5.7,7.3l2.4,1.9l4.9-6.3l1.8,1.4l-4.9,6.3l2.8,2.2l5.9-7.5l1.8,1.4l-7.5,9.6 L220.9,209.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M230.9,196.1l3.7-7.1c1.5-2.8,3.2-4.5,6-2.9c2.2,1.1,2.5,3.3,1.7,5.1l6.7-1.1l-1.5,2.8l-6.4,1l-1.9,3.6 l4.6,2.4l-1.2,2.3L230.9,196.1z M239.7,192.1c1-1.9,1.2-3-0.2-3.7c-1.4-0.7-2.2,0.1-3.1,2l-2.3,4.4l3.3,1.7L239.7,192.1z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M220.8,250v1H218v7.3h-1.1V251h-2.8v-1H220.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M221.8,250h1.6l2.4,7l2.4-7h1.6v8.3h-1.1v-4.9c0-0.2,0-0.5,0-0.8c0-0.4,0-0.8,0-1.3l-2.4,7h-1.1l-2.4-7v0.3 c0,0.2,0,0.5,0,0.9c0,0.4,0,0.7,0,0.9v4.9h-1.1V250z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLogoWithPaddings);
export default __webpack_public_path__ + "static/media/new-logo-with-paddings.2588b3c7089cd15d89e9cdb8dade4509.svg";
export { ForwardRef as ReactComponent };